/* eslint-disable camelcase */
// EXCEPCIÓN TEMPORAL - ¡NO REPLICAR ESTE PATRÓN DE DESACTIVAR EL ESLINT!
import React, { useState, useEffect } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Box,
  CircularProgress,
  TextField,
} from "@mui/material"
import { useMutation, api, showWarning } from "../../../api"

const ModalActivosPendientes = ({ open, onClose, cocid, onActivosSeleccionados }) => {
  const [activosPendientes, setActivosPendientes] = useState([])
  const [seleccionados, setSeleccionados] = useState([])

  const { mutateAsync: fetchDetalleOC, isPending: isLoading } = useMutation({
    mutationFn: async (data) => {
      const response = await api.post("/AltasPPE/getDetalleOCPendienteCXP", data)
      const rawData = response?.data || response
      const extractTrueArray = (obj) => {
        if (Array.isArray(obj)) {
          if (obj.length === 2 && obj[1] === 200) return extractTrueArray(obj[0])
          return obj
        }
        if (obj && typeof obj === "object" && obj.data) return extractTrueArray(obj.data)
        return []
      }
      return extractTrueArray(rawData)
    },
  })

  useEffect(() => {
    if (open && cocid) cargarDatos()
    else {
      setActivosPendientes([])
      setSeleccionados([])
    }
  }, [open, cocid])

  const cargarDatos = async () => {
    try {
      const resultArray = await fetchDetalleOC({ cocid })
      const activosConSaldo = resultArray
        .map((item, index) => {
          const cantDetalle = Number(item.cantdet || item.CANTDET || 0)
          const cantAlta = Number(item.cantalta || item.CANTALTA || 0)
          return {
            ...item,
            id: item.tocid || item.TOCID || `activo-${index}`,
            cantidad_pendiente: item.cantidad_pendiente ?? cantDetalle - cantAlta,
            cantidad_a_ingresar: item.cantidad_pendiente ?? cantDetalle - cantAlta,
          }
        })
        .filter((item) => item.cantidad_pendiente > 0)

      if (activosConSaldo.length > 0) setActivosPendientes(activosConSaldo)
      else {
        showWarning("No hay activos pendientes.")
        onClose()
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleSelect = (id) => {
    setSeleccionados((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]))
  }

  const handleConfirmar = () => {
    if (seleccionados.length === 0) return showWarning("Seleccione al menos un activo.")

    const activosElegidos = activosPendientes.filter((activo) => seleccionados.includes(activo.id))
    const registrosExpandidos = []

    for (const activo of activosElegidos) {
      const cantProcesar = Number(activo.cantidad_a_ingresar)
      if (cantProcesar <= 0 || cantProcesar > activo.cantidad_pendiente) {
        showWarning(`Cantidad inválida para ${activo.artdescripcion || activo.ARTDESCRIPCION}`)
        return
      }

      for (let i = 0; i < cantProcesar; i++) {
        registrosExpandidos.push({
          ...activo,
          fila_id: `${activo.id}-${i}-${Date.now()}`,
          serie: "",
          gendescri: activo.gendescri || activo.GENDESCRI,
          artdescripcion: activo.artdescripcion || activo.ARTDESCRIPCION,
          marca: activo.marca || activo.MARCA,
          modelo: activo.modelo || activo.MODELO,
        })
      }
    }

    onActivosSeleccionados(registrosExpandidos)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ backgroundColor: "primary.main", color: "white" }}>
        Activos Pendientes (OC: {cocid})
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {isLoading ? (
          <Box display="flex" justifyContent="center" p={5}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      onChange={(e) => setSeleccionados(e.target.checked ? activosPendientes.map((a) => a.id) : [])}
                    />
                  </TableCell>
                  <TableCell>
                    <b>Descripción</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Saldo</b>
                  </TableCell>
                  <TableCell align="center" sx={{ width: 150 }}>
                    <b>Cant. a Ingresar</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Costo Unit.</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {activosPendientes.map((activo, idx) => (
                  <TableRow key={activo.id} hover selected={seleccionados.includes(activo.id)}>
                    <TableCell padding="checkbox">
                      <Checkbox checked={seleccionados.includes(activo.id)} onClick={() => handleSelect(activo.id)} />
                    </TableCell>
                    <TableCell>{activo.artdescripcion || activo.ARTDESCRIPCION}</TableCell>
                    <TableCell align="right">{activo.cantidad_pendiente}</TableCell>
                    <TableCell align="center">
                      <TextField
                        size="small"
                        type="number"
                        value={activo.cantidad_a_ingresar}
                        onChange={(e) => {
                          const val = e.target.value
                          const newP = [...activosPendientes]
                          newP[idx].cantidad_a_ingresar = val
                          setActivosPendientes(newP)
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">${Number(activo.toccostouni || 0).toFixed(2)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleConfirmar} variant="contained" disabled={seleccionados.length === 0}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default ModalActivosPendientes
